<div class="layout-main">
  <div class="container-fluid">
    <div *roles="['ROLE_CLIENT']" class="mb-3">
      You don't have the required permission to access this page.
    </div>
    <div *roles="['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN']">
      <div class="row">
        <div class="pb-2 mb-3 border-bottom col-12">
          <h2>
            <b>Symbol Data Download Log</b>
          </h2>
        </div>
      </div>
      <p-panel [toggleable]="true">
        <ng-template pTemplate="header">
          <span class="filter-title p-panel-title"><i class="fa fa-search"></i> Filter</span>
        </ng-template>
        <div *ngIf="permission">
          <div class="d-flex align-items-center p-fluid" style="gap: 1rem;">
            <div class="flex-fill">
              <p-floatLabel>
                <p-dropdown (onChange)="filter()"
                            [(ngModel)]="symbolDataDownloadLogFilterCriteria.type"
                            [options]="typeItems"
                            inputId="type">
                </p-dropdown>
                <label for="type">Type</label>
              </p-floatLabel>
            </div>
            <div class="flex-fill">
              <p-floatLabel>
                <p-dropdown (onChange)="filter()"
                            [(ngModel)]="symbolDataDownloadLogFilterCriteria.company"
                            [filter]="true"
                            [options]="companyItems"
                            [showClear]="true"
                            inputId="company"
                            placeholder="All">
                </p-dropdown>
                <label for="company">Company</label>
              </p-floatLabel>
            </div>
            <div class="flex-fill">
              <p-floatLabel>
                <p-dropdown (onChange)="filter()"
                            [(ngModel)]="symbolDataDownloadLogFilterCriteria.user"
                            [filter]="true"
                            [options]="userItems"
                            [showClear]="true"
                            inputId="user"
                            placeholder="All">
                </p-dropdown>
                <label for="user">User Email</label>
              </p-floatLabel>
            </div>
            <div class="flex-fill">
              <p-floatLabel>
                <p-dropdown (onChange)="filter()"
                            [(ngModel)]="symbolDataDownloadLogFilterCriteria.downloadedData"
                            [filter]="true"
                            [options]="downloadedDataItems"
                            [showClear]="true"
                            inputId="downloadedData"
                            placeholder="All">
                </p-dropdown>
                <label for="downloadedData">Downloaded Data</label>
              </p-floatLabel>
            </div>
            <div class="flex-shrink-0" style="width: 150px;">
              <p-floatLabel>
                <p-calendar (onSelect)="filter()" [(ngModel)]="symbolDataDownloadLogFilterCriteria.dateFrom"
                            [showIcon]="true" dataType="string" dateFormat="mm/dd/yy" inputId="dateFrom">
                </p-calendar>
                <label for="dateFrom">Date From</label>
              </p-floatLabel>
            </div>
            <div class="flex-shrink-0" style="width: 150px;">
              <p-floatLabel>
                <p-calendar (onSelect)="filter()" [(ngModel)]="symbolDataDownloadLogFilterCriteria.dateTo"
                            [showIcon]="true" dataType="string" dateFormat="mm/dd/yy" inputId="dateTo">
                </p-calendar>
                <label for="dateTo">Date To</label>
              </p-floatLabel>
            </div>
            <div class="flex-shrink-0 mt-3">
              <button (click)="resetTable()" icon="fa fa-refresh" pButton title="Reset"
                      type="button"></button>
            </div>
          </div>
        </div>
      </p-panel>
      <div *ngIf="symbolDataDownloadLogList" class="row mt-3">
        <div class="col-12">
          <p-table (onLazyLoad)="loadLazy($event)" [columns]="cols" [customSort]="true" [lazy]="true" [paginator]="true"
                   [rows]="20"
                   [totalRecords]="totalItems" [value]="symbolDataDownloadLogList">
            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of cols" [pSortableColumnDisabled]="!col.sortable"
                    [pSortableColumn]="col.field">
                  {{ col.header }}
                  <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template let-downloadLog pTemplate="body">
              <tr [pSelectableRow]="downloadLog">
                <td>{{ downloadLog.createdAt | date : 'MMM d, y H:mm' }}</td>
                <td>{{ downloadLog.downloadedData }}</td>
                <td>{{ downloadLog.type }}</td>
                <td style="overflow: hidden; text-overflow: ellipsis;">
                  {{ getUserName(downloadLog) }}
                </td>
                <td style="overflow: hidden; text-overflow: ellipsis;">
                  {{ getUserCompanyName(downloadLog) }}
                </td>
                <td style="overflow: hidden; text-overflow: ellipsis;">
                  {{ getUserEmail(downloadLog) }}
                </td>
                <td>{{ downloadLog.method }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              {{ totalItems }} results
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>

